import { managerFactory } from "@/factories/manager";
import { initializeDatadogRumClient } from "@/manager/datadog-rum-client/initialize";

export const datadogRumClientManager = managerFactory.create({
  initializer: initializeDatadogRumClient,
});
